import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface WorkDefaultsState {
  accountId?: string;
  start?: string;
  end?: string;
}

const initialState: WorkDefaultsState = {
  accountId: undefined,
  start: undefined,
  end: undefined,
};

const slice = createSlice({
  name: 'workDefaults',
  initialState,
  reducers: {
    setWorkDefaults: (state, action: PayloadAction<{ accountId?: string; start?: string; end?: string }>) => {
      state.accountId = action.payload.accountId ?? state.accountId;
      state.start = action.payload.start;
      state.end = action.payload.end;
    },
    resetWorkDefaults: () => initialState,
  },
});

export default slice.reducer;

export const { setWorkDefaults, resetWorkDefaults } = slice.actions;
